<template>
  <v-card
    class="
      d-flex
      flex-column
      align-start
      justify-center
      px-5
      pr-12
      py-10 py-lg-16
      item
    "
    height="100%"
    tile
    flat
  >
    <img class="d-block item-img" :src="files + img" height="80px" />

    <div class="white--text text-body-1 font-weight-bold mt-7">
      {{ title }}
    </div>
  </v-card>
</template>

<script>
export default {
  props: {
    img: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.item {
  background: linear-gradient(180deg, #003399 0%, #0051ac 100%);

  &-img {
    -o-object-fit: contain;
    object-fit: contain;
    width: auto;
  }
}
</style>
